module.exports = __webpack_public_path__ + "img/kolobok.c2dc1808.svg";